export default {
    grades() {
        return axios.get('/api/ecommerce/grades');
    },
    seasons() {
        return axios.get('/api/ecommerce/seasons');
    },
    divisiongroups(division_type) {
        return axios.get('/api/ecommerce/divisiongroups/' + division_type);
    },
    divisions(division_group) {
        return axios.get('/api/ecommerce/divisions/' + division_group);
    },
    preferreddivisions(division) {
        return axios.get('/api/ecommerce/preferreddivisions/' + division);
    },
    teamnomination(division) {
        return axios.get('/api/ecommerce/teamnomination/' + division);
    },
    checkplayer(player, division, fromteamentry) {
        return axios.post('/api/ecommerce/teamnomination/checkplayer', {player, division, fromteamentry});
    },
    payteamnom(data) {
        return axios.post('/api/ecommerce/teamnomination/payteamnom', data);
    }
};
